export default function TitleDivider({ title }) {
  return (
    <div className="prose max-w-none">
      <h2 className="mt-8 mb-2">
        { title }
      </h2>
      <div className="divider"></div>
    </div>
  )
}